import EngagementScheduleFilter from "modules/dashboards/engagement/EngagementScheduleFilter";
import EngagementSchedule from "modules/dashboards/engagement/EngagementSchedule";
import React, { useEffect, useMemo, useState } from "react";
import useEngagementStore from "modules/dashboards/engagement/store/index";
import {
  getFormattedStartDate,
  getFormattedEndDate,
  revenueRepStartDate,
  revenueRepEndDate,
  engagementScheduleFn,
} from "functionCall";
import secureLocalStorage from "react-secure-storage";

function Engagement({ subTab }) {
  const {
    engagementData,
    teamData,
    isLoading,
    error,
    fetchEngData,
    fetchTeamData,
  } = useEngagementStore();
  const [startDate, setStartDate] = useState(getFormattedEndDate(1));
  const [endDate, setEndDate] = useState(getFormattedStartDate());
  const [engStartDate, setEngStartDate] = useState(
    encodeURIComponent(revenueRepStartDate(startDate))
  );
  const [engEndDate, setEngEndDate] = useState(
    encodeURIComponent(revenueRepEndDate(endDate))
  );
  const [startFilterDate, setStartFilterDate] = useState("");
  const [endFilterDate, setEndFilterDate] = useState("");
  const [clear, setClear] = useState(false);

  useEffect(() => {
    if (subTab == "engagement") {
      if (clear) {
        fetchEngData(engStartDate, engEndDate);
        return;
      }
      if (startFilterDate && endFilterDate) {
        if (startFilterDate == endFilterDate) {
          return;
        }
        let startFilter = encodeURIComponent(
          revenueRepStartDate(startFilterDate)
        );
        let endFilter = encodeURIComponent(revenueRepEndDate(endFilterDate));
        fetchEngData(startFilter, endFilter);
      } else {
        fetchEngData(engStartDate, engEndDate);
        fetchTeamData();
      }
    }
  }, [startFilterDate, endFilterDate, clear, subTab]);

  const repIds = useMemo(() => {
    let defaultOptions = {
      [secureLocalStorage.getItem("id")]: secureLocalStorage?.getItem("first_name"),
    };
    if (teamData) {
      defaultOptions = teamData[0]?.userGroup?.reduce((acc, curr) => {
        if (curr?.user_id) {
          acc[curr.user_id] = curr?.user?.first_name || "N/A";
          return acc;
        }
      }, defaultOptions);
    }
    return defaultOptions;
  }, [teamData?.length > 0 ? teamData : null]);

  const engagementSchedule = useMemo(() => {
    return engagementScheduleFn({
      engagements: engagementData,
      reminders: [],
    });
  }, [engagementData]);

  const modifiedData = useMemo(() => {
    return engagementSchedule?.map((row) => {
      const copyRow = { ...row };
      copyRow.hairCoach = repIds && repIds[copyRow?.hairCoach];
      return copyRow;
    });
  }, [engagementSchedule, repIds]);

  return (
    <div className="d-flex flex-column">
      <div className="d-flex justify-content-between">
        <div className="">
          <h3>Engagement Schedule</h3>
        </div>
        <div className="">
          <EngagementScheduleFilter
            setStartFilterDate={setStartFilterDate}
            setEndFilterDate={setEndFilterDate}
            setClear={setClear}
          />
        </div>
      </div>
      <div className="mt-2">
        <EngagementSchedule
          modifiedData={modifiedData}
          isLoading={isLoading}
          error={error}
        />
      </div>
    </div>
  );
}

export default Engagement;
